// Validate if email is empty
export const validateemail = (email: string): string => {
    if (!email) {
      return "email is required"
    }
    return ""
  }
  
  // Validate if password is empty
  export const validatePassword = (password: string): string => {
    if (!password) {
      return "Password is required"
    }
    return ""
  }
  
  // Validate if email is in correct format (for password reset)
  export const validateEmail = (email: string): string => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
    if (!email) {
      return "Email is required"
    }
    if (!emailPattern.test(email)) {
      return "Please enter a valid email address"
    }
    return ""
  }